
import React from "react";
import { useNavigate } from "react-router-dom";
import Placeholder from "./placeholder";

export default function ExportReports() {
  return <Placeholder title="Export Reports" description="Generate and export project reports in various formats" />;
}
